import React, { useState } from 'react';
import { WhatsappIcon } from 'react-share';
import { ExclamationCircleFill, X } from 'react-bootstrap-icons';
import { Dialog, DialogPanel, Transition, TransitionChild } from '@headlessui/react';
import PhoneInput, { isValidPhoneNumber, parsePhoneNumber } from 'react-phone-number-input';
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { useDispatch, useSelector } from 'react-redux';
import flags from 'react-phone-number-input/flags';
import { submitLeadForm } from '../../redux/actions/micrositeAction';
import useMicroSiteEncrypt from '../CustomHook/useMicroSiteEncrypt';

const WhatsappButton = ({ data, scrollToSection }) => {  
  const dispatch = useDispatch();
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [nameError, setNameError] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [open, setOpen] = useState(false);
  const [countryCode, setCountryCode] = useState('');
  const { microSiteEncrypt, token, error } = useMicroSiteEncrypt();
  const url_data = useSelector((state) => state.microsite?.url_data);
  const home_data = useSelector((state) => state.microsite?.home_data);
  const [message, setMessage] = useState(home_data?.whatsApp_message || " Hi, I would like to connect with you on WhatsApp to seek your financial advice.");
  const customize_fields = useSelector((state) => state.microsite?.home_data?.customization);
    
  const submitForm = async () => {
        // Mint the reCAPTCHA token at submit time, not on mount
        let freshRecaptchaToken = "";
        if (executeRecaptcha) {
          try {
            freshRecaptchaToken = await executeRecaptcha("lead_form");
          } catch (err) {
            console.error("reCAPTCHA execute failed:", err);
          }
        }
        if (!freshRecaptchaToken) {
          return;
        }

        let payload = {
        fullname: name,
        phoneNo: countryCode+"-"+mobile?.replace(countryCode,""),
        recaptcha_token: freshRecaptchaToken,
        url: url_data
        }
        
        const generateToken = async () => {
            const token = await microSiteEncrypt(payload);
            if (token && token !== "") {
                dispatch(submitLeadForm(token ,payload, "WhatsApp", "", onSuccess))
            }
        };
        
        generateToken();
  }
  
  const handleCountryChange = (value) => {
    if (value) {
      try {
        const phoneNumberObj = parsePhoneNumber(value);
        const countryCode = '+' + phoneNumberObj?.countryCallingCode;
        setCountryCode(countryCode);
      } catch (error) {
        console.error('Invalid phone number', error);
      }
    } else {
      setCountryCode('');
    }
  };
  
  const onSuccess = () => {
    setOpen(false);
    setName("");
    setMobile("");
  }
  
  
  return (
    <div>
        <WhatsappIcon onClick={()=>{setOpen(true)}} className='rounded-full cursor-pointer w-12 h-12 fixed right-5 top-1/2 transform -translate-y-1/2 z-10'/>
      
        <Transition show={open}>
          <Dialog className="relative z-10" onClose={setOpen}>
            <TransitionChild
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </TransitionChild>

            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
              <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                <TransitionChild
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <DialogPanel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full max-sm:w-full sm:max-w-xl">
                    <div className="px-8 max-sm:px-4 py-4">
                    <X
                      className="absolute right-2 top-2 z-50 text-[#222] cursor-pointer text-2xl"
                        onClick={() => { setOpen(false); setMobileError(false); setNameError(false); setMobile(""); }}
                    />
                    <div className="flex justify-center m-0 p-0">
                      <WhatsappIcon className='rounded-full'/>
                    </div>
                    <div className="border-b pb-4 my-4">
                      <p className="text-[24px] max-sm:text-xl font-[TATAAIARegularPrint] text-center font-semibold">Let's Connect</p>
                    </div>
                    <form action="#" method="POST" className="my-4">
                      <div className="">
                        <div className="sm:col-span-3">
                          <div className="mt-1">
                            <textarea
                              name="message"
                              id="message"
                              rows={3}
                              className="block w-full resize-none font-[HelveticaNeueLTStd] rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset custom_ring_color sm:text-sm sm:leading-5"
                              value={message}
                              onChange={(e)=>{setMessage(e.target.value)}}
                            />
                          </div>
                        </div>    
                        <div className='flex max-sm:block mt-4 mb-8'>
                          <div className='w-1/2 max-sm:w-full max-sm:pr-0 pr-12'>
                            <div className="mt-1 relative">
                              <input
                                type="text"
                                name="name"
                                id="name"
                                className={`block w-full font-[HelveticaNeueLTStd] h-9 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ${nameError != false ? "ring-red-300 focus:ring-red-300":"ring-gray-300 custom_ring_color"}  placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:text-xs sm:leading-6`}
                                value={name}
                                placeholder={"Your name"+ (customize_fields?.whatsapp_contact?.name?.validation == "required" ? " *":"")}
                                onChange={(e) => {  
                                  const regex = /^[a-zA-Z ]*$/;
                                  if (regex.test(e.target.value)) {
                                    setName(e.target.value);
                                  }  
                                  if (e.target.value != "") {
                                    setNameError(false);
                                  }
                                }}
                              />
                              {nameError != false && <ExclamationCircleFill title="Enter a name" className="text-xs absolute top-1/2 text-[#D62049] -translate-y-1/2 right-1.5"/>}
                            </div>
                          </div>
                          <div className='w-1/2 max-sm:mt-4 max-sm:w-full'>
                            <div className="mt-1 relative country-customize delay-form">
                              <PhoneInput
                                flags={flags}  
                                className='font-[HelveticaNeueLTStd]'                                
                                placeholder={"Your mobile number"+ (customize_fields?.whatsapp_contact?.name?.validation == "required" ? " *":"")}
                                value={mobile}
                                defaultCountry="IN"
                                countryCallingCodeEditable={false}
                                international={true}  
                                limitMaxLength  
                                onChange={(e) => {
                                  handleCountryChange(e);  
                                  if (e) {
                                    setMobile(e)
                                    if (isValidPhoneNumber(e)) {
                                        setMobileError(false); 
                                    } else {
                                        setMobileError(true); 
                                    }
                                  } else {
                                    setMobile("");
                                    setMobileError(false); 
                                  }
                                }}
                              />
                              {mobileError != false && <ExclamationCircleFill title="Enter a valid mobile number" className="text-xs absolute top-1/2 text-[#D62049] -translate-y-1/2 right-1.5"/>}
                            </div>
                          </div>
                        </div>
                        <button
                          type="button"
                          className={`flex w-auto mx-auto bg-[#2b9452] justify-center items-center gap-2.5 shrink-0 border px-5 pb-1 pt-1.5 rounded-[30px] border-solid border-[#fff]`}
                          onClick={() => {
                              if (name == "" && customize_fields?.whatsapp_contact?.name?.validation == "required") {
                                setNameError(true);
                                return;
                              } else if ((mobile == "" || mobileError == true) && customize_fields?.whatsapp_contact?.phone?.validation == "required" ) {
                                setMobileError(true);
                                return;
                              } else {
                                setNameError(false);
                                setMobileError(false);
                              }
                              submitForm();
                              let anchor = document.createElement('a');
                              anchor.href = `https://api.whatsapp.com/send?phone=${home_data?.microsite?.contact}&text=${message}`;
                              anchor.target = '_blank';
                              document.body.appendChild(anchor);
                              anchor.click();
                            }}
                        >
                          <span className="text-[#fff] font-[TATAAIARegularPrint] text-sm not-italic leading-5">
                            Share message
                          </span>
                        </button>
                      </div>
                    </form>
                  </div>
                  </DialogPanel>
                </TransitionChild>
              </div>
            </div>
          </Dialog>
        </Transition>
    </div>
  );
};

export default WhatsappButton;